<template>
  <div class="container">
    <div class="headImgs_box">
      <img class="headImgs" src="../../assets/fangyi/topbg.png" alt="" />
      <div class="text">
        信“疫”贷专区产品放贷累计金额{{
          numberFormat(loansCount.loanCumulativeAmount * 10000)
        }}、放贷累计户数{{ loansCount.loanNum }}户
      </div>
    </div>
    <div class="onekey_box">
      <img src="../../assets/fangyi/onekeytitle.png" alt="" />
      <div class="flex_box">
        <div class="flex_item" v-for="(item, index) in onekeylist" :key="index">
          <div class="logo_box">
            <img :src="baseUrl + item.imgIcon" alt="" />
            <!-- <img v-if="item.name == '苏州银行征信贷'" src="../../assets/fangyi/6cab0b50f350900e7f4d719b0800962.png" alt="">
            <img v-else src="../../assets/fangyi/021c1d2cd33541b8a9c282248f7dac3.png" alt=""> -->
          </div>
          <h2 class="title_name">{{ item.name }}</h2>
          <div class="info">
            <div>
              <h1 style="color: #b90c1c">
                {{ item.loanLimitFloor }}-{{ item.loanLimitCap }}
              </h1>
              <span>授信额度（万元）</span>
            </div>
            <div
              style="border-left: 1px solid #ddd; border-right: 1px solid #ddd"
            >
              <h1>{{ item.interestRateFloor }}-{{ item.interestRateCap }}</h1>
              <span>利率</span>
            </div>
            <div>
              <h1>{{ item.minLoanTime }}-{{ item.maxLoanTime }}</h1>
              <span>贷款（月）</span>
            </div>
          </div>
          <div class="btn_box">
            <el-button type="danger" @click="lijishenqing(item.id)"
              >立即申请</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="jinrong_box">
      <img src="../../assets/fangyi/jrtitle.png" alt="" />
      <div class="firm_title_img">
        <img src="../../assets/fangyi/kjyltitle.png" alt="" />
      </div>
      <div class="brand_box">
        <div class="swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(obj, index) in bankinglist3"
              :key="index"
            >
              <div class="item">
                <div class="logo_box">
                  <img :src="baseUrl + obj.imgIcon" alt="" />
                </div>
                <h2 class="title_name">{{ obj.name }}</h2>
                <div class="ed_info">
                  <div>
                    <h1 style="color: #b90c1c">
                      {{ obj.loanLimitFloor }}-{{ obj.loanLimitCap }}
                    </h1>
                    <span>授信额度（万元）</span>
                  </div>
                </div>
                <div class="info">
                  <div>
                    <h1>
                      {{ obj.interestRateFloor }}-{{ obj.interestRateCap }}
                    </h1>
                    <span>利率</span>
                  </div>
                  <div>
                    <h1>{{ obj.minLoanTime }}-{{ obj.maxLoanTime }}</h1>
                    <span>贷款（月）</span>
                  </div>
                </div>
                <div class="code_box">
                  <img :src="baseUrl + obj.qrCode" alt="" />
                </div>
                <div class="btn_box"></div>
              </div>
            </div>
          </div>
          <!--wrapper-->
          <!-- 分页器结构-->
          <div class="swiper-pagination"></div>
          <!-- 加导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <div class="firm_title_img">
        <img src="../../assets/fangyi/xwqytitle.png" alt="" />
      </div>
      <!-- <div class="brand_box">
        <el-carousel height="530px" arrow="always" indicator-position="outside">
          <el-carousel-item
            v-for="(item, index) in getDataList"
            :key="index"
            :autoplay="bankinglist2.length >= 3 ? true : false"
          >
            <div
              v-for="obj in item"
              :key="obj.pro_id"
              class="item"
              :style="getStyle(obj)"
            >
              <div class="logo_box">
                <img :src="baseUrl + obj.imgIcon" alt="" />
              </div>
              <h2 class="title_name">{{ obj.name }}</h2>
              <div class="ed_info">
                <div>
                  <h1 style="color: #b90c1c">
                    {{ obj.loanLimitFloor }}-{{ obj.loanLimitCap }}
                  </h1>
                  <span>授信额度（万元）</span>
                </div>
              </div>
              <div class="info">
                <div>
                  <h1>{{ obj.interestRateFloor }}-{{ obj.interestRateCap }}</h1>
                  <span>利率</span>
                </div>
                <div>
                  <h1>{{ obj.minLoanTime }}-{{ obj.maxLoanTime }}</h1>
                  <span>贷款（月）</span>
                </div>
              </div>
              <div class="code_box">
                <img :src="baseUrl + obj.qrCode" alt="" />
              </div>
              <div class="btn_box"></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div> -->
      <div class="brand_box">
        <div class="swiper-container" ref="mySwiper1">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(obj, index) in bankinglist"
              :key="index"
            >
              <div class="item">
                <div class="logo_box">
                  <img :src="baseUrl + obj.imgIcon" alt="" />
                </div>
                <h2 class="title_name">{{ obj.name }}</h2>
                <div class="ed_info">
                  <div>
                    <h1 style="color: #b90c1c">
                      {{ obj.loanLimitFloor }}-{{ obj.loanLimitCap }}
                    </h1>
                    <span>授信额度（万元）</span>
                  </div>
                </div>
                <div class="info">
                  <div>
                    <h1>
                      {{ obj.interestRateFloor }}-{{ obj.interestRateCap }}
                    </h1>
                    <span>利率</span>
                  </div>
                  <div>
                    <h1>{{ obj.minLoanTime }}-{{ obj.maxLoanTime }}</h1>
                    <span>贷款（月）</span>
                  </div>
                </div>
                <div class="code_box">
                  <img :src="baseUrl + obj.qrCode" alt="" />
                </div>
                <div class="btn_box"></div>
              </div>
            </div>
          </div>
          <!--wrapper-->
          <!-- 分页器结构-->
          <div class="swiper-pagination"></div>
          <!-- 加导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <!-- <div class="next_btn_box" @click="gotochanpin">查看更多</div> -->
      <div class="firm_title_img">
        <img src="../../assets/fangyi/gtgshtitle.png" alt="" />
      </div>
      <div class="brand_box">
        <div class="swiper-container" ref="mySwiper2">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(obj, index) in bankinglist2"
              :key="index"
            >
              <div class="item">
                <div class="logo_box">
                  <img :src="baseUrl + obj.imgIcon" alt="" />
                </div>
                <h2 class="title_name">{{ obj.name }}</h2>
                <div class="ed_info">
                  <div>
                    <h1 style="color: #b90c1c">
                      {{ obj.loanLimitFloor }}-{{ obj.loanLimitCap }}
                    </h1>
                    <span>授信额度（万元）</span>
                  </div>
                </div>
                <div class="info">
                  <div>
                    <h1>
                      {{ obj.interestRateFloor }}-{{ obj.interestRateCap }}
                    </h1>
                    <span>利率</span>
                  </div>
                  <div>
                    <h1>{{ obj.minLoanTime }}-{{ obj.maxLoanTime }}</h1>
                    <span>贷款（月）</span>
                  </div>
                </div>
                <div class="code_box">
                  <img :src="baseUrl + obj.qrCode" alt="" />
                </div>
                <div class="btn_box"></div>
              </div>
            </div>
          </div>
          <!--wrapper-->
          <!-- 分页器结构-->
          <!-- <div class="swiper-pagination"></div> -->
          <!-- 加导航按钮 -->
          <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from "../../api/baseUrl";
import {
  dedicatedList0,
  dedicatedList1,
  dedicatedList2,
  dedicatedList3,
  dedicatedCount,
} from "@/api/fangyi";
import Swiper from "swiper/js/swiper";

export default {
  components: {},
  data() {
    return {
      onekeylist: [],
      bankinglist: [],
      bankinglist2: [],
      bankinglist3: [],
      loansCount: {},
    };
  },
  computed: {
    getDataList() {
      const newArr = [];
      let arr = [];
      for (let j = 0; j < 4; j++) {
        for (let i = 0; i < this.bankinglist.length; i++) {
          if (arr.length < 4) {
            arr.push(this.bankinglist[i]);
          } else {
            newArr.push([].concat(arr));
            arr = [this.bankinglist[i]];
          }
        }
      }
      if (arr.length) newArr.push(arr);
      return newArr;
    },
    getDataList2() {
      const newArr = [];
      let arr = [];
      for (let j = 0; j < 4; j++) {
        for (let i = 0; i < this.bankinglist2.length; i++) {
          if (arr.length < 4) {
            arr.push(this.bankinglist2[i]);
          } else {
            newArr.push([].concat(arr));
            arr = [this.bankinglist2[i]];
          }
        }
      }
      if (arr.length) newArr.push(arr);
      return newArr;
    },
    getDataList3() {
      const newArr = [];
      let arr = [];
      for (let j = 0; j < 4; j++) {
        for (let i = 0; i < this.bankinglist3.length; i++) {
          if (arr.length < 4) {
            arr.push(this.bankinglist3[i]);
          } else {
            newArr.push([].concat(arr));
            arr = [this.bankinglist3[i]];
          }
        }
      }
      if (arr.length) newArr.push(arr);
      return newArr;
    },
  },
  created() {
    //   一键授信
    dedicatedList0(this.sendParam({ type: 0 })).then((res) => {
      res = this.paramDecrypt(res);
      console.log(res);
      if (res.code == 200) {
        this.onekeylist = res.data;
      }
    });
    // 小微企业
    dedicatedList1(this.sendParam({ type: 1 })).then((res) => {
      res = this.paramDecrypt(res);
      console.log(res);
      if (res.code == 200) {
        this.bankinglist = res.data;
      }
    });
    // 个体工商户
    dedicatedList2(this.sendParam({ type: 2 })).then((res) => {
      res = this.paramDecrypt(res);
      console.log(res);
      if (res.code == 200) {
        this.bankinglist2 = res.data;
      }
    });
    // 科技医疗...
    dedicatedList3(this.sendParam({ type: 2 })).then((res) => {
      res = this.paramDecrypt(res);
      console.log(res);
      if (res.code == 200) {
        this.bankinglist3 = res.data;
      }
    });
    // 贷款金额
    dedicatedCount(this.sendParam({})).then((res) => {
      res = this.paramDecrypt(res);
      console.log(res);
      if (res.code == 200) {
        this.loansCount = res.data;
        console.log(this.numberFormat(res.data.loanCumulativeAmount * 10000));
      }
    });
  },
  mounted() {
    setTimeout(() => {
      this.swiper3();
      this.swiper2();
      this.swiper1();
    }, 500);
  },
  methods: {
    getStyle(item) {
      return {
        backgroundImage: "url(" + baseUrl + item.background + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      };
    },
    onSlideChange() {
      console.log("111");
    },
    gotochanpin() {
      this.$router.push("/xyd/fangyichanpin");
    },
    numberFormat(value) {
      let unit = "";
      var k = 10000,
        sizes = ["", "万", "亿", "万亿"],
        i;
      if (value < k) {
        value = value;
      } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        value = (value / Math.pow(k, i)).toFixed(2);
        unit = sizes[i];
      }
      console.log(value);
      if (value && value !== 'NaN') {
        return value + unit;
      }else{
        return ""
      }
    },

    // 立即申请
    lijishenqing(id) {
      const token = sessionStorage.getItem("token");
      if (token) {
        if (id == 2) {
          this.$router.push("/xyd/SzzxdApply");
        } else if (id == 1) {
          this.$router.push("/xyd/SznshApply");
        }
      } else {
        this.$message.error("请先登录");
        this.$router.push("/xyd/login");
        return;
      }
    },
    swiper3() {
      new Swiper(this.$refs.mySwiper, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    swiper2() {
      new Swiper(this.$refs.mySwiper2, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        // loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      });
    },
    swiper1() {
      new Swiper(this.$refs.mySwiper1, {
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "my-button-disabled",
        },
      });
    },
  },
};
</script>

<style lang='less' scoped>
.container {
  position: relative;
  background-color: #fff;
  .headImgs_box {
    width: 100vw;
    height: 567px;
    position: relative;
    .headImgs {
      width: 100vw;
      height: 100%;
    }
    .text {
      width: 800px;
      position: absolute;
      top: 270px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      color: #fadec4;
      font-size: 23px;
      text-shadow: 0px 0px 1px rgb(207, 193, 193);
      // text-shadow: 3px 5px 3px rgb(104, 101, 101);
    }
  }

  .onekey_box {
    width: 1280px;
    // height: 300px;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 30px;
    background: #ffecec;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    margin: 0 auto;
    position: relative;
    top: -250px;
    .flex_box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 20px;
      .flex_item {
        width: 550px;
        // margin-right: 50px;
        background-color: #fff;
        border: 1px solid #d5d5d5;
        .logo_box {
          width: 100%;
          height: 80px;
          line-height: 100px;
          background-image: url(../../assets/fangyi/onekeytitlebg.png);
          background-size: 100% 100%;
          text-align: center;
          img {
            width: 250px;
            // height: 48px;
          }
        }
        .title_name {
          text-align: center;
          font-size: 28px;
        }
        .info {
          display: flex;
          justify-content: space-around;
          div {
            width: 200px;
            text-align: center;
            padding: 0 35px;
            h1 {
              margin: 0;
            }
            span {
              display: block;
              color: #595858;
            }
          }
        }
        .btn_box {
          margin-top: 20px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }
      }
    }
  }
  .jinrong_box {
    width: 1280px;
    // background: #ffecec;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    // opacity: 0.6;
    border-radius: 6px;
    margin: 0 auto;
    position: relative;
    top: -230px;
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 200px;
      margin: 0;
    }
    .firm_title_img {
      text-align: center;
      margin: 20px 0 10px;
    }
    .next_btn_box {
      width: 150px;
      height: 40px;
      border: 1px solid #d01e16;
      border-radius: 25px;
      color: #d01e16;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      margin: 30px auto;
    }
  }
}
/deep/.el-button--danger {
  background-color: #c5160d !important;
  padding-left: 50px;
  padding-right: 50px;
}
/deep/.el-carousel {
  height: 580px;
  padding: 0 40px;
}
/deep/.el-carousel__indicators {
  position: relative;
  bottom: 50px;
  // left: -50px
  left: 0px;
}
/deep/.el-carousel__button {
  display: block;
  opacity: 0.3;
  width: 10px;
  height: 10px;
  background-color: #fff !important;
  border-radius: 50%;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
/deep/ .el-carousel__button {
  background-color: red !important;
}
/deep/.swiper-pagination-bullet {
  width: 10px !important;
  height: 10px !important;
}
/deep/.swiper-container {
  // overflow-y: none;
  // overflow-y: none !important;
  overflow-x: hidden;
  height: 540px;
}
/deep/.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 50px;
  left: 0;
  width: 100%;
}
.brand_box {
  //   width: 100%;
  padding: 10px 0;
  .swiper-button-prev {
    color: red;
  }
  .swiper-button-next {
    color: red;
  }
  .item {
    width: 92%;
    height: 435px;
    box-sizing: border-box;
    text-align: left;
    background-color: #fff;
    border: 1px solid #d5d5d5;
    margin: 0 10px;
    cursor: pointer;
    position: relative;
    .logo_box {
      width: 100%;
      height: 80px;
      line-height: 90px;
      background-image: url(../../assets/fangyi/bankingtitlebg.png);
      background-size: 100% 100%;
      text-align: center;
      img {
        font-size: 0;
        //   width: 150px;
        //   height: 28px;
      }
    }
    .title_name {
      text-align: center;
      font-size: 23px;
    }
    .ed_info {
      display: flex;
      justify-content: space-around;
      div {
        width: 200px;
        text-align: center;
        //   padding: 0 35px;
        h1 {
          margin: 0;
          font-size: 22px;
        }
        span {
          display: block;
          color: #595858;
          position: relative;
          left: 5px;
        }
      }
    }
    .info {
      display: flex;
      justify-content: space-around;
      margin-top: 30px;
      div {
        width: 200px;
        text-align: center;
        //   padding: 0 35px;
        h1 {
          margin: 0;
          color: #000;
          font-size: 20px;
        }
        span {
          display: block;
          color: #595858;
          font-size: 14px;
          position: relative;
          left: 5px;
        }
      }
    }
    .code_box {
      text-align: center;
      margin-bottom: 20px;
      margin-top: 20px;
      position: relative;
      // bottom: -10px;
      z-index: 20;
      img {
        width: 130px;
      }
    }
    .btn_box {
      width: 100%;
      height: 10px;
      background: #d01e16;
      margin-top: 35px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      position: absolute;
      bottom: 0;
    }
  }
  /deep/.el-carousel__item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: auto;
    margin-top: 20px;

    .item {
      width: 23%;
      box-sizing: border-box;
      text-align: left;
      background-color: #fff;
      border: 1px solid #d5d5d5;
      margin: 0 10px;
      cursor: pointer;
      position: relative;
      .logo_box {
        width: 100%;
        height: 80px;
        line-height: 90px;
        background-image: url(../../assets/fangyi/bankingtitlebg.png);
        background-size: 100% 100%;
        text-align: center;
        img {
          font-size: 0;
          //   width: 150px;
          //   height: 28px;
        }
      }
      .title_name {
        text-align: center;
        font-size: 23px;
      }
      .ed_info {
        display: flex;
        justify-content: space-around;
        div {
          width: 200px;
          text-align: center;
          //   padding: 0 35px;
          h1 {
            margin: 0;
            font-size: 22px;
          }
          span {
            display: block;
            color: #595858;
            position: relative;
            left: 5px;
          }
        }
      }
      .info {
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        div {
          width: 200px;
          text-align: center;
          //   padding: 0 35px;
          h1 {
            margin: 0;
            color: #000;
            font-size: 20px;
          }
          span {
            display: block;
            color: #595858;
            font-size: 14px;
            position: relative;
            left: 5px;
          }
        }
      }
      .code_box {
        text-align: center;
        margin-bottom: 20px;
        margin-top: 20px;
        position: relative;
        // bottom: -10px;
        z-index: 20;
        img {
          width: 120px;
        }
      }
      .btn_box {
        width: 100%;
        height: 10px;
        background: #d01e16;
        margin-top: 35px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>